'use strict';

module.exports = {
    createEnum: require('./createEnum'),
    instanceOfEnum: require('./instanceOfEnum')
};



// WEBPACK FOOTER //
// ./assets/js/global/utils/enum/index.es.js